'use es6';

import RestoreReportsListingPage from './RestoreReportsListingPage';
import { setRestorableReportsFilters } from '../actions/reportsActions';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import getInitialFilters from '../lib/getInitialFilters';
import { jsx as _jsx } from "react/jsx-runtime";
const RestoreDeletedReportsContainer = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    const initialFilters = getInitialFilters();
    dispatch(setRestorableReportsFilters(initialFilters.reportFilters));
  }, [dispatch]);
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "restore-page",
    children: /*#__PURE__*/_jsx(RestoreReportsListingPage, {})
  });
};
RestoreDeletedReportsContainer.propTypes = {};
export default RestoreDeletedReportsContainer;